import React from "react"

export default class HopeWorks extends React.Component {

    render() {
        return (
        <h1>Create a Todo List</h1>
        )
    }
}